// @owners { team: patients }
import { DateRestrictionReasonMap } from '@alto/scriptdash/alto/scheduling/types/v1/date_restriction_reason';
import { normalizeDateStringStrict } from '~shared/helpers/date';

/** Commercial refill-too-soon reasons routed through the get-it-sooner run-insurance flow.
 * Progyny is excluded because re-running insurance cannot move its refill date. */
export const reasonIsRefillTooSoon = (reason: string) =>
  reason === DateRestrictionReasonMap.REFILL_TOO_SOON || reason === DateRestrictionReasonMap.DELIVERED_RECENTLY;

export const reasonIsProgynyRefillTooSoon = (reason: string) =>
  reason === DateRestrictionReasonMap.PROGYNY_REFILL_TOO_SOON;

/**
 * Patient-facing copy for a Progyny refill-too-soon date floor.
 *
 *
 * @param date next available date, in the API's `yyyy-MM-dd`
 * @returns the copy, or '' when the date is missing or unparseable
 */
export const getProgynyNextRefillMessage = (date: string | undefined): string => {
  const formattedDate = date ? normalizeDateStringStrict(date) : null;

  return formattedDate ? `Next refill: ${formattedDate}` : '';
};

/**
 * Explains when a selected date is too soon and that the earliest available date can be chosen.
 */
export const getProgynyNextRefillDateError = (date: string | undefined): string => {
  const message = getProgynyNextRefillMessage(date);

  return message ? `${message}. Please choose that date or later.` : '';
};
